import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material/TableCell";
import s from "./language.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Pagination,
} from "@mui/material";
import { notificationHandler } from "../../utils/Notification";
import Loder from "../../Loder/Loder";
import { BiFilter, BiSearch } from "react-icons/bi";
import DataNotFound from "../ErrorPage/DataNotFound";
import { IoMdAdd } from "react-icons/io";
import {
  deleteLanguage_api,
  getLanguages_api,
  updateLanguage_api,
  updateLanguage_status_api,
} from "../api/librarymedia";
import { getBaseUrl2 } from "../../utils";

const LibraryMediaList = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [libraryMedia, setlibraryMedia] = useState([]);
  const [pageCount, setpageCount] = useState(1);
  const [deleteId, setdeleteId] = useState("");
  const [deletePopup, setdeletePopup] = useState(false);
  const [currentGroup, setcurrentGroup] = useState({});
  const [search, setsearch] = useState("");
  const [pageLength, setpageLength] = useState();
  // this is for view more or  view less
  const [viewMore, setviewMore] = useState(true);

  useEffect(() => {
    fetchallLibraryMediaFunc();
    // fetchallTagFunc();
  }, [pageCount, search]);

  // console.log(libraryMedia, "Library media list");

  async function fetchallLibraryMediaFunc(data) {
    setisLoading(true);
    try {
      const temp = {
        page: pageCount,
        limit: 15,
        search: search.trim(),
      };
      let res = await getLanguages_api(temp);
      if (res.data.status) {
        setlibraryMedia(res?.data?.data?.libraryMedia);
        setpageLength(res?.data?.data?.total_page);
        setisLoading(false);
      } else {
        setisLoading(false);
        console.log("status false!");
      }
    } catch (error) {
      console.log(error);
      setisLoading(false);
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--clr-theme)",
      color: theme.palette.common.white,
      fontWeight: "bold",
      borderRight: "1px solid #fff",
      overflow: "hidden",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "none",
      borderLeft: "2px solid #00000011",
      "&:last-child": {
        borderRight: "2px solid #00000011",
      },
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "2px solid #00000011",
  }));
  async function deleteuserFunc() {
    setisLoading(true);
    try {
      let res = await deleteLanguage_api(deleteId);
      console.log(res);
      if (res.data.status) {
        setisLoading(false);
        setdeletePopup(false);
        fetchallLibraryMediaFunc();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setisLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
    }
  }

  const language_status = async (data) => {
    setisLoading(true);
    let temp = {
      id: data.id,
      status: data.status == true ? false : true,
    };
    try {
      let res = await updateLanguage_api(temp);
      console.log(res);
      if (res.data.status) {
        setisLoading(false);
        fetchallLibraryMediaFunc();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setisLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
    }
  };

  const handleViewMoreFunc = (lyrics, index) => {
    let lyricsLength = lyrics?.split("").length;
    if (lyricsLength < 10) {
      return { __html: lyrics };
    } else {
      return { __html: lyrics?.split(" ")?.slice(0, 10) };
    }
  };

  const [expandedRows, setExpandedRows] = useState({}); // Track expanded items
  const [expandedEnglishRows, setexpandedEnglishRows] = useState({}); // Track expanded items

  const handleToggle = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle only the clicked item
    }));
  };
  const handleEnglishToggle = (index) => {
    setexpandedEnglishRows((prev) => ({
      ...prev,
      [index]: !prev[index], // Toggle only the clicked item
    }));
  };

  return (
    <div className="">
      <div className="beat_heading">
        <div className={s["user-list-heading"]}>
          <div className="user-list-title">
            <h3>Library Media List</h3>
          </div>
          <div className={s["user-list-search"]}>
            <div className={s["search-box"]}>
              <span style={{ paddingRight: "0.5rem" }}>
                <BiSearch size={23} />
              </span>
              <input
                type="text"
                spellCheck="false"
                onChange={(e) => {
                  setpageCount(1);
                  setsearch(e.target.value);
                }}
                placeholder="Search by name..."
              />
            </div>
            <div className={s["filter-btn"]}>
              <span style={{ paddingRight: "2px" }}>
                <BiFilter size={20} />
              </span>
              Filter
            </div>
          </div>
        </div>
        <div className="beat_left">
          <div
            className={s["title"]}
            onClick={() =>
              navigate("/add-library-media", {
                state: {
                  pagetype: "Add",
                },
              })
            }
          >
            <IoMdAdd /> Library Media
          </div>
        </div>
      </div>
      <div
        className="beat_table"
        style={{ overflowX: "auto", display: "flex" }}
      >
        <Table
          sx={{ minWidth: 700 }}
          aria-label="customized table"
          style={{ minWidth: "100%", width: "max-content" }}
        >
          <TableHead>
            <TableRow>
              <StyledTableCell align="center" stylw>
                Thumbnail
              </StyledTableCell>
              <StyledTableCell
                align="center"
                style={{ minWidth: "300px", maxWidth: "300px", width: "300px" }}
              >
                Title English
              </StyledTableCell>
              <StyledTableCell
                align="center"
                style={{ minWidth: "300px", maxWidth: "300px", width: "300px" }}
              >
                Title Hindi
              </StyledTableCell>
              <StyledTableCell align="center">Tags</StyledTableCell>
              <StyledTableCell
                style={{ minWidth: "300px", maxWidth: "300px", width: "300px" }}
              >
                Lyrics Hindi
              </StyledTableCell>

              <StyledTableCell
                align="center"
                style={{ minWidth: "300px", maxWidth: "300px", width: "300px" }}
              >
                English Lyrics
              </StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          {/* <div style={{ margin: "0.5rem 0" }}></div> */}
          <TableBody>
            {libraryMedia?.map((row, index) => (
              <StyledTableRow key={row.id}>
                <StyledTableCell>
                  <img
                    src={getBaseUrl2() + row?.thumbnail?.url}
                    style={{ width: "50px", height: "50px" }}
                    alt="thumbnail"
                  />
                </StyledTableCell>
                <StyledTableCell>{row?.titleEnglish} </StyledTableCell>
                <StyledTableCell>{row?.titleHindi} </StyledTableCell>
                <StyledTableCell>{row?.tags?.join(" ,")} </StyledTableCell>
                <StyledTableCell
                  style={{
                    minWidth: "300px",
                    maxWidth: "300px",
                    width: "300px",
                  }}
                >
                  {expandedRows[index] ? (
                    <div style={{ maxWidth: "300px" }}>
                      <div
                        dangerouslySetInnerHTML={{ __html: row?.lyrics?.hindi }}
                      ></div>
                      <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => handleToggle(index)}
                      >
                        ...view less
                      </span>
                    </div>
                  ) : (
                    <div style={{ maxWidth: "300px" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            row?.lyrics?.hindi
                              ?.split(" ")
                              .slice(0, 10)
                              .join(" ") + " ...",
                        }}
                      ></div>
                      <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => handleToggle(index)}
                      >
                        ...view more
                      </span>
                    </div>
                  )}
                </StyledTableCell>
                <StyledTableCell
                  style={{
                    minWidth: "300px",
                    maxWidth: "300px",
                    width: "300px",
                  }}
                >
                  {expandedEnglishRows[index] ? (
                    <div style={{ maxWidth: "300px" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: row?.lyrics?.english,
                        }}
                      ></div>
                      <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => handleEnglishToggle(index)}
                      >
                        ...view less
                      </span>
                    </div>
                  ) : (
                    <div style={{ maxWidth: "300px" }}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            row?.lyrics?.english
                              ?.split(" ")
                              .slice(0, 10)
                              .join(" ") + " ...",
                        }}
                      ></div>
                      <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => handleEnglishToggle(index)}
                      >
                        ...view more
                      </span>
                    </div>
                  )}
                </StyledTableCell>
                {/* <StyledTableCell align="center">
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => language_status(row)}
                    className={`${row.status === true ? s.active_admin : s.inactive_admin
                      }`}
                  >
                    {row.status === true ? "Active" : "Inactive"}
                  </div>
                </StyledTableCell> */}

                <StyledTableCell align="center">
                  <CiEdit
                    onClick={() =>
                      navigate("/edit-library-media", {
                        state: {
                          pagetype: "Edit",
                          data: row,
                        },
                      })
                    }
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      marginRight: "0.5rem",
                      cursor: "pointer",
                    }}
                  />
                  <MdDelete
                    onClick={() => {
                      setdeletePopup(true);
                      setcurrentGroup(row);
                      setdeleteId(row._id);
                    }}
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      cursor: "pointer",
                    }}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
        {/* {libraryMedia?.length <= 0 && <DataNotFound />} */}
      </div>
      {libraryMedia?.length > 0 && (
        <div className={s["pagination"]}>
          <Pagination
            count={pageLength}
            size="large"
            style={{ color: "#D21903" }}
            onChange={(e, value) => setpageCount(value)}
            page={pageCount}
          />
        </div>
      )}
      <Dialog
        open={deletePopup}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
        fullWidth="true"
        onClose={() => setdeletePopup(false)}
      >
        <DialogTitle className={s.dialog_title}>
          <div>Do you want to delete {currentGroup.titleEnglish}?</div>
        </DialogTitle>
        <DialogContent className={s.cardpopup_content}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div
              className={s.employee_gl_popup}
              onClick={() => setdeletePopup(false)}
            >
              Cancel
            </div>
            <div
              className={s.employee_gl_popup_del}
              onClick={() => deleteuserFunc()}
            >
              Delete
            </div>
          </div>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Loder loading={isLoading} />
    </div>
  );
};

export default LibraryMediaList;
